<div
  #energyScoreColumn
  class="product-column-general product-energy-score"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | method: 'getSectionBorderMarginSize'">
  <app-handle-badge-mode
    [rowVm]="rowVm"
    [colVm]="colVm"
    [nonListColumnBadgeAsset]="this | method: 'getNonListColumnItem'">
    {{ this | method: 'getNonListColumnItem' }}
  </app-handle-badge-mode>
</div>
